<template>
  <!--
          作者 gmshop
          时间：2020-06-09
          描述：会员-等级管理
      -->
  <div class="user">

    <div class="common-seach-wrap">
      <el-form size="small" :inline="true" :model="searchForm" class="demo-form-inline">
        <el-form-item label="类目名称"><el-input size="small" v-model="searchForm.third_cat_name" placeholder="请输入类目名称"></el-input></el-form-item>
        <el-form-item label="一级类目名称"><el-input size="small" v-model="searchForm.first_cat_name" placeholder="请输入一级类目名称"></el-input></el-form-item>
        <el-form-item label="二级类目名称"><el-input size="small" v-model="searchForm.second_cat_name" placeholder="请输入二级类目名称"></el-input></el-form-item>
        <el-form-item>
          <el-button size="small" type="primary" icon="el-icon-search" @click="onSubmit">查询</el-button>
        </el-form-item>
      </el-form>
    </div>

    <!--添加等级-->
    <!-- <div class="common-level-rail">
      <el-button size="small" type="primary" @click="synShopCat" icon="el-icon-plus" v-auth="'/ministore/shopcat/syn'">同步类目</el-button>
      <div class="gray9">第一次需要同步类目，无需频繁同步更新，如果小程序申请新的类目需要重新同步</div>
    </div> -->

    <!--内容-->
    <div class="product-content">
      <div class="table-wrap">
        <el-tabs v-model="activeName" @tab-click="handleClick">
          <el-tab-pane label="全部类目" name="all"></el-tab-pane>
          <el-tab-pane label="申请资质" name="apply"></el-tab-pane>
          <el-tab-pane label="已启用" name="enabled"></el-tab-pane>
        </el-tabs>
        <el-table size="small" :data="tableData" border style="width: 100%" v-loading="loading">
          <el-table-column prop="third_cat_name" label="类目名称"></el-table-column>
          <el-table-column prop="first_cat_name" label="一级类目名称"></el-table-column>
          <el-table-column prop="second_cat_name" label="二级类目名称"></el-table-column>
          <el-table-column prop="qualification_type" label="类目资质" width="200">
            <template slot-scope="scope">
              <span class="red fb" v-if="scope.row.qualification_type==1">
                必须申请资质
                <span class="red fb" v-if="scope.row.status==-1">
                  （待申请）
                </span>
                <span class="red fb" v-if="scope.row.status==0">
                  （申请中）
                </span>
                <span class="red fb" v-if="scope.row.status==1">
                  （已通过）
                </span>
                <span class="red fb" v-if="scope.row.status==9">
                  （已拒绝）
                </span>
              </span>
              <span v-else class="fb">无需申请资质</span>
            </template>
          </el-table-column>
          <el-table-column prop="product_qualification_type" label="商品资质" width="200">
            <template slot-scope="scope">
              <span class="red fb" v-if="scope.row.product_qualification_type==1">必须上传商品资质</span>
              <span v-else class="fb">无需申请资质</span>
            </template>
          </el-table-column>
          <el-table-column prop="enabled" label="是否启用" width="200">
            <template slot-scope="scope">
              <span class="red fb" v-if="scope.row.enabled==1">已启用</span>
              <span v-else class="fb">未启用</span>
            </template>
          </el-table-column>
          <el-table-column fixed="right" label="操作" width="90">
            <template slot-scope="scope">
              <el-button v-if="scope.row.qualification_type==1" @click="applyClick(scope.row)" type="text" size="small" v-auth="'/ministore/shopcat/apply'" >申请资质</el-button>
              <el-button v-if="scope.row.qualification_type==1 && scope.row.status==1" @click="enabledClick(scope.row)" type="text" size="small" v-auth="'/ministore/shopcat/enabled'" >启用</el-button>
              <el-button v-if="scope.row.qualification_type==0" @click="enabledClick(scope.row)" type="text" size="small" v-auth="'/ministore/shopcat/enabled'" >启用</el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>

      <!--分页-->
      <div class="pagination">
        <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" background :current-page="curPage"
          :page-size="pageSize" layout="total, prev, pager, next, jumper"
          :total="totalDataNumber">
        </el-pagination>
      </div>
    </div>

    <!--申请资质-->
    <Apply v-if="open_apply" :open_apply="open_apply" :form="detailModel" @closeDialog="closeDialogFunc($event)"></Apply>
  </div>
</template>

<script>
  import MinistoreApi from '@/api/ministore.js';
  import Apply from './apply.vue';
  import {deepClone} from '@/utils/base.js';
  export default {
    components: {
      Apply
    },
    data() {
      return {
        /*是否加载完成*/
        loading: true,
        /*列表数据*/
        tableData: [],
        /*一页多少条*/
        pageSize: 20,
        /*一共多少条数据*/
        totalDataNumber: 0,
        /*当前是第几页*/
        curPage: 1,
        /*横向表单数据模型*/
        searchForm: {
          third_cat_name: '',
          first_cat_name: '',
          second_cat_name: '',
        },
        activeName: 'all',
        open_apply: false,
        /*当前编辑的对象*/
        detailModel: {}
      };
    },
    created() {

      /*获取列表*/
      this.getTableList();
    },
    methods: {

      /*选择第几页*/
      handleCurrentChange(val) {
        let self = this;
        self.curPage = val;
        self.loading = true;
        self.getTableList();
      },

      /*每页多少条*/
      handleSizeChange(val) {
        this.curPage = 1;
        this.pageSize = val;
        this.getTableList();
      },

      /*切换菜单*/
      handleClick(tab, event) {
        let self = this;
        self.curPage = 1;
        self.getTableList();
        self.loading = true;
      },

      /*获取列表*/
      getTableList() {
        let self = this;
        let Params = self.searchForm;
        Params.activeName = self.activeName;
        Params.page = self.curPage;
        Params.list_rows = self.pageSize;
        MinistoreApi.shopCatlist(Params, true)
          .then(data => {
            self.loading = false;
            self.tableData = data.data.list.data;
            self.totalDataNumber = data.data.list.total
          })
          .catch(error => {

          });
      },

      onSubmit() {
        this.curPage = 1;
        this.getTableList();
      },

      /*打开编辑*/
      applyClick(item) {
        console.log(item);
        this.detailModel = deepClone(item);
        this.open_apply = true;
      },

      /*关闭弹窗*/
      closeDialogFunc(e) {
        this.open_apply = e.openDialog;
        if (e.type == 'success') {
          this.getTableList();
        }
      },

      /*启用类目*/
      enabledClick(row) {
        let self = this;
        self.$confirm('是否启用类目?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          self.loading = true;
          MinistoreApi.enabled({
              cat_id: row.cat_id
            }, true)
            .then(data => {
              self.loading = false;
              if (data.code == 1) {
                self.$message({
                  message: data.msg,
                  type: 'success'
                });
                self.getTableList();
              } else {
                self.$message.error('错了哦，这是一条错误消息');
              }
            })
            .catch(error => {
              self.loading = false;
            });

        }).catch(() => {

        });
      },

      synShopCat(){
        MinistoreApi.synShopCat({}, true)
          .then(data => {
            self.$message({
              message: data.msg,
              type: 'success'
            });
            self.getTableList();
          })
          .catch(error => {

          });
      }

    }
  };
</script>

<style></style>



// WEBPACK FOOTER //
// src/views/ministore/shopcat/index.vue